import { FuuzeColors, yupLocale } from '@fuuze/shared';
import { StrictMode } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Vibrant, WorkerPipeline } from 'node-vibrant/worker';
import PipelineWorker from 'node-vibrant/worker.worker?worker';
import { setLocale } from 'yup';
import App from './App';
import { FirebaseService } from './services/firebase.service';

setLocale(yupLocale);
FirebaseService.initializeApp();
Vibrant.use(new WorkerPipeline(PipelineWorker as never));

// Display App

const container = document.getElementById('root')!;
let root: Root | undefined;

if (!root) {
  root = createRoot(container);
}

root.render(
  <StrictMode>
    <SkeletonTheme baseColor={FuuzeColors.dark.dark200} highlightColor={FuuzeColors.dark.dark300}>
      <App />
    </SkeletonTheme>
  </StrictMode>,
);
